<div class="flyout-time-overview-component">
  @if (flyoutDataType !== FlyoutDataTypes.Session) {
    <div class="time-column">
      <span class="label">{{ "flyout.last-seen" | translate }}</span>
      <span class="value" [matTooltipDisabled]="!latestVisitTimestamp" matTooltip="{{ latestVisitTimestamp }}">
        {{ latestVisitString ? latestVisitString : "N/A" }}
      </span>
    </div>
    <div class="time-column">
      <span class="label">{{ (flyoutDataType === FlyoutDataTypes.Session ? "flyout.session-start" : "flyout.first-visit") | translate }}</span>
      <span class="value last" [matTooltipDisabled]="!firstVisitTimestamp" matTooltip="{{ firstVisitTimestamp }}">
        {{ firstVisitString ? firstVisitString : "N/A" }}
      </span>
    </div>
  }
  @if (flyoutDataType === FlyoutDataTypes.Session) {
    <div class="time-column">
      <span class="label">{{ "flyout.session-start" | translate }}</span>
      <span class="value last" [matTooltipDisabled]="!firstVisitTimestampNumber" matTooltip="{{ firstVisitTimestamp }}">
        {{ firstVisitTimestampNumber ? (firstVisitTimestampNumber / 1000 | formatDate) : "N/A" }}
      </span>
    </div>
    <div class="time-column">
      <span class="label">{{ "generic.length" | translate }}</span>
      <span class="value">{{ secondsOnSite && secondsOnSite > 0 ? (secondsOnSite | prettySeconds) : "N/A" }}</span>
    </div>
  }
</div>
